const arr = [
  {
    src:
      "https://res.cloudinary.com/dtrp3lqrw/image/upload/v1643637613/Photoshop/PicsArt_04-12-12.38.23_ibxtyv.jpg",
    title: "infinity mountain"
  },
  {
    src:
      "https://res.cloudinary.com/dtrp3lqrw/image/upload/v1643637623/Photoshop/IMG_20211017_001634_078_m21eu8.jpg",
    title: "ohh u save nature"
  },
  {
    src:
      "https://res.cloudinary.com/dtrp3lqrw/image/upload/v1643637613/Photoshop/IMG_20211017_001709_325_qvpsdp.jpg",
    title: "abstract view"
  },
  {
    src:
      "https://res.cloudinary.com/dtrp3lqrw/image/upload/v1643637613/Photoshop/IMG_20211017_001810_026_hc4jdh.jpg",
    title: "The moon land"
  },
  {
    src:
      "https://res.cloudinary.com/dtrp3lqrw/image/upload/v1643637612/Photoshop/PicsArt_06-26-10.37.35_e5xa9l.png",
    title: "the creepy rose"
  },
  {
    src:
      "https://res.cloudinary.com/dtrp3lqrw/image/upload/v1643637611/Photoshop/moon_4_1_qj2dlv.jpg",
    title: "floating moon "
  },
  {
    src:
      "https://res.cloudinary.com/dtrp3lqrw/image/upload/v1643637610/Photoshop/PicsArt_01-10-05.16.45_lk2lok.jpg",
    title: "I don't care"
  },
  {
    src:
      "https://res.cloudinary.com/dtrp3lqrw/image/upload/v1643637607/Photoshop/PicsArt_05-22-06.05.39_jv9rcw.jpg",
    title: "we love and born again"
  },
  {
    src:
      "https://res.cloudinary.com/dtrp3lqrw/image/upload/v1643637607/Photoshop/IMG_20211017_001556_339_zmqcxy.jpg",
    title: "where is our home"
  },
  {
    src:
      "https://res.cloudinary.com/dtrp3lqrw/image/upload/v1643637606/Photoshop/IMG_20211017_001906_707_kvd8ax.jpg",
    title: "search for infinty"
  },
  {
    src:
      "https://res.cloudinary.com/dtrp3lqrw/image/upload/v1643637606/Photoshop/IMG_20211017_001347_029_vbrkzb.jpg",
    title: "the giant nemo"
  }
];

export default arr;
